<template>
  <div class="page">
    开发设置
  </div>
</template>

<script>
export default {
  name: 'develop',
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
</style>
